// extracted by mini-css-extract-plugin
module.exports = {"opreation-button":"opreation-button-d3dda05260edf22f91a37ec8acfcf907"};